package com.shadowings.gero.util

import kotlinx.browser.window

// Compose Multiplatform's Locale.current reads window.navigator.language/.languages live on
// Kotlin/JS (see androidx.compose.ui.text.intl.Locale.web.kt) — there is no Configuration-style
// override hook like Android/iOS have, so we override the browser properties directly. App.kt's
// languageEpoch bump (right after calling this) forces stringResource() call sites to recompose
// and pick the change up.
actual fun setAppLanguage(languageCode: String) {
    if (languageCode.isBlank()) return
    overrideNavigatorLanguage(languageCode)
}

private fun overrideNavigatorLanguage(lang: String): Unit = js(
    """
    {
        try {
            Object.defineProperty(window.navigator, 'language', {
                configurable: true,
                get: function() { return lang; }
            });
            Object.defineProperty(window.navigator, 'languages', {
                configurable: true,
                get: function() { return [lang]; }
            });
        } catch (e) {}
    }
    """
)

actual fun systemLanguageCode(): String {
    return runCatching {
        window.navigator.language.take(2).lowercase()
    }.getOrDefault("it")
}
